import { Client } from '@connectrpc/connect';

import { LFDOverridesService } from './espb/lfd_overrides_service_pb';
import EspbServiceClientFactory from './EspbServiceClientFactory';
import { ClientType } from './types';

export default class LFDOverridesAdminClient {
  private readonly espbClient: Client<typeof LFDOverridesService>;

  constructor(
    public readonly baseUri: string,
    public readonly authToken: string,
    public readonly clientType: ClientType,
    public readonly clientId?: string,
    public readonly clientVersion?: string,
  ) {
    const factory = new EspbServiceClientFactory({
      authTokens: {
        lfdOverridesAdmin: authToken,
      },
      clientId,
      clientType,
      clientVersion,
      baseUri,
      syncSuperUsers: false,
    });
    this.espbClient = factory.createServiceClient(LFDOverridesService);
  }

  async replace(...overrideJson: string[]): Promise<void> {
    await this.espbClient.replace({ overrideJson });
  }

  async delete(...overrideIds: string[]): Promise<void> {
    await this.espbClient.delete({ overrideIds });
  }
}
